export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-11-1bd7f16310b22f3751649124465b78d9.png";